import { useState, useLayoutEffect } from "react";

/**
 * A hook to calculate the styles needed to break an element out of its container
 * and span the full width of the main scrollable area, avoiding horizontal scroll.
 */
export function useBreakoutWidth() {
  const [breakoutStyle, setBreakoutStyle] = useState<React.CSSProperties>({});

  useLayoutEffect(() => {
    const mainEl = document.querySelector("main");

    const updateStyle = () => {
      if (mainEl) {
        const clientWidth = mainEl.clientWidth;
        setBreakoutStyle({
          width: `${clientWidth}px`,
          marginLeft: `calc(50% - ${clientWidth / 2}px)`,
          maxWidth: "none", // Ensure it's not constrained by parent max-width
        });
      }
    };

    updateStyle();

    // Use ResizeObserver to update width when sidebar collapses/expands or window resizes
    if (mainEl && typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(updateStyle);
      observer.observe(mainEl);
      return () => observer.disconnect();
    }
  }, []);

  return breakoutStyle;
}
